import React from 'react';
import Col from 'react-bootstrap/Col';
import Slider from 'react-slick';
import properties from '../../../modules/ajio-util/properties';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

class Capsules extends React.Component {
  render() {
    const pagedetails = this.props.pagedetails;
    const bannerDetail = pagedetails.bannerImageDetails;
    const widgetType = pagedetails.typeCode;
    const sectionName = this.props.componentTitle
      ? this.props.componentTitle
      : pagedetails.typeCode;
    if (bannerDetail === undefined) {
      return null;
    }

    var arr = [];

    bannerDetail.map((bannerimagedetails, j) => {
      arr.push({
        id: j,
        uId: bannerimagedetails.uId,
        imageUrl: bannerimagedetails.imageUrl,
        urlLink: bannerimagedetails.bannerUrlLink,
        bannerPos: bannerimagedetails.bannerPosition,
        componentPos: bannerimagedetails.componentPosition
      });
    });

    let imageGallery = arr.map((data, i) => {
      let bannerImgUrl = '';
      bannerImgUrl =
        data.imageUrl.indexOf('?') == -1
          ? data.imageUrl
          : data.imageUrl.substr(0, data.imageUrl.indexOf('?'));
      return (
        <Col xs={6} key={i} className="gallery-section">
          <a
            href={data.urlLink}
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${data.componentPos}/${widgetType}`}
            data-ga-event-label={`${bannerImgUrl}/${data.bannerPos}`}
            data-gtm-bnr-position={`${data.componentPos}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(data.imageUrl) || ''}`}
            data-gtm-bnr-id={`${data.uId || ''}`}
          >
            <img src={`${replaceWithJioCDN(data.imageUrl)}`} className="img-animate" />
          </a>
        </Col>
      );
    });

    return <div className="gallery-com row">{imageGallery}</div>;
  }
}

export default BannerWrapper(Capsules);
